// 全局按钮点击节流处理
export const btnThrottle = (delay = 300, id = 'app-click-container') => {
  // 获取当前dom元素app_click_container
  const appClickContainer = document.getElementById(id);
  // 如果存在，在appClickContainer中添加点击事件
  if (appClickContainer) {
    appClickContainer.onclick = (e) => {
      let nowDelay = delay;
      // 获取当前点击的元素，判断是否是button, 如果不是找父元素判断是否是button，否则不处理
      let target: any = e.target;
      if (!target) {
        return;
      }
      if (target?.tagName !== 'BUTTON') {
        // 获取点击元素e的父元素
        target = target.parentNode;
      }
      // 如果是button，并且忽略class等于ant-switch,和属性上no-throttle的按钮
      if (
        target?.tagName === 'BUTTON' &&
        !target?.classList.contains('ant-switch') &&
        target?.getAttribute('no-throttle') === null
      ) {
        if (target?.getAttribute('delay')) {
          nowDelay = parseInt(target.getAttribute('delay'));
        }
        //  如果按钮已被禁用，则阻止按钮的默认行为
        if (target?.getAttribute('disabled')) {
          e.preventDefault();
        } else {
          // 禁用按钮
          target?.setAttribute('disabled', 'true');
          // 1秒后重新启用按钮
          setTimeout(() => {
            target?.removeAttribute('disabled');
          }, nowDelay);
        }
      }
    };
  }
};
